import React from 'react';
import Button from 'react-bootstrap/Button';
import Icon from './icon';

export function OptionTag({
  onClick,
  label,
}: {
  label: string;
  onClick: () => void;
}) {
  return (
    <Button
      variant='light'
      style={{
        borderWidth: '1px',
      }}
      className='bg-white text-dark border-dark btn-xs mr-1 mt-1 text-nowrap py-1 px-1 font-weight-normal d-flex align-items-center'
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <Icon name='close' />
      <span
        title={label}
        style={{
          maxWidth: '200px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          textAlign: 'left',
        }}
      >
        {label}
      </span>
    </Button>
  );
}
